import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout';
import { useAuth } from '../../context/AuthContext';
import { filterMenuItems } from '../../utils/menuAccess';
import './ControlesPage.css';

const controleItems = [
  { label: 'Parametres de loterie', icon: '🎯', path: '/controles/parametres-loterie' },
  { label: 'Numeros Controle',      icon: '🔢', path: '/controles/number-control' },
  { label: 'Eliminar Parametros',   icon: '🗑️', path: '/controles/eliminar-parametros' },
  // { label: 'Controlee Numbers',     icon: '🔢', path: null },
  // { label: 'Rapport',               icon: '📋', path: null },
  // { label: 'Rep. Parametros',       icon: '📋', path: null },
  // { label: 'Loterias',              icon: '🔄', path: null },
];

const ControlesPage = () => {
  const { company } = useAuth();
  const visibleItems = useMemo(
    () => filterMenuItems(controleItems, company?.menu_keys),
    [company?.menu_keys],
  );

  return (
    <Layout>
      <p className="ctl-breadcrumb">
        Ruta : <Link to="/dashboard" className="bc-link">Menu</Link>
        {' >> '}
        <Link to="/controles" className="bc-link">Controles</Link>
      </p>

      <div className="ctl-grid">
        {visibleItems.map((item) => (item.path ? (
          <Link key={item.label} to={item.path} className="ctl-item">
            <div className="ctl-icon">{item.icon}</div>
            <span className="ctl-label">{item.label}</span>
          </Link>
        ) : (
          <div key={item.label} className="ctl-item">
            <div className="ctl-icon">{item.icon}</div>
            <span className="ctl-label ctl-label-disabled">{item.label}</span>
          </div>
        )))}
      </div>
    </Layout>
  );
};

export default ControlesPage;
